import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AcmChannel } from "./campaign3testservice";
import { HttpClientService } from "app/services/httpClient/httpclient.service";


@Injectable()
export class Accumulator3Service {




    constructor(private http: HttpClientService) { }

    acmUrl = "/koncentro-loyalty/acm/acm_channel?acm_id="
    

    //GET /koncentro-loyalty/acm/acm_channel/{id_acm_channel}
    getAcmLoyChannelList(id): Observable<Array<AcmChannel>> {
        return this.http.get(this.acmUrl + id.toString());
    }
    saveAcmLoyChannel(payload:AcmChannel){
        return this.http.postPaged(this.acmUrl,payload)
    }


    deleteAcmLoyChannel(row:AcmChannel){
        let  deleteurl=`/koncentro-loyalty/acm/acm_channel/${row.id}`
        return this.http.delete(deleteurl);
    }

    recoverAcmLoyChannel(row:AcmChannel){
        let  recoverUrl=`/koncentro-loyalty/acm/acm_channel/recover/${row.id}`
        return this.http.putPaged(recoverUrl,row);
    }
    editAcmLoyChannel(payload: AcmChannel) {
        let acmId = payload.acm_id;
        let channelId = payload.channel_id;
        let editUrl = `/koncentro-loyalty/acm/${acmId}/channel/${channelId}`;
        return this.http.putPaged(editUrl, payload);
    }
    deleteFatherAcm(id){
        let deleteFatherUrl= `/koncentro-loyalty/acm/${id}`;
        return this.http.delete(deleteFatherUrl);
    }


}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/services/accumulator3.service.ts